import { makeActionCreator } from '../../../../../utilities'
import { DrainsAndTubesConstants } from './drainsAndTubes.constants'

export const setNgTube = makeActionCreator(DrainsAndTubesConstants.SET_NG_TUBE, 'ngTube')
export const setNgTubeSuction = makeActionCreator(DrainsAndTubesConstants.SET_NG_TUBE_SUCTION, 'ngTubeSuction')
export const setOgTube = makeActionCreator(DrainsAndTubesConstants.SET_OG_TUBE, 'ogTube')
export const setOgTubeSuction = makeActionCreator(DrainsAndTubesConstants.SET_OG_TUBE_SUCTION, 'ogTubeSuction')
export const setChestTubeL = makeActionCreator(DrainsAndTubesConstants.SET_CHEST_TUBE_L, 'chestTubeL')
export const setChestTubeLSuction = makeActionCreator(
  DrainsAndTubesConstants.SET_CHEST_TUBE_L_SUCTION,
  'chestTubeLSuction'
)
export const setChestTubeR = makeActionCreator(DrainsAndTubesConstants.SET_CHEST_TUBE_R, 'chestTubeR')
export const setChestTubeRSuction = makeActionCreator(
  DrainsAndTubesConstants.SET_CHEST_TUBE_R_SUCTION,
  'chestTubeRSuction'
)
export const setFoley = makeActionCreator(DrainsAndTubesConstants.SET_FOLEY, 'foley')
export const setFoleyColor = makeActionCreator(DrainsAndTubesConstants.SET_FOLEY_COLOR, 'foleyColor')
export const setPegTube = makeActionCreator(DrainsAndTubesConstants.SET_PEG_TUBE, 'pegTube')
export const setPegTubeCapped = makeActionCreator(DrainsAndTubesConstants.SET_PEG_TUBE_CAPPED, 'pegTubeCapped')
export const setIleostomy = makeActionCreator(DrainsAndTubesConstants.SET_ILEOSTOMY, 'ileostomy')
export const setColostomy = makeActionCreator(DrainsAndTubesConstants.SET_COLOSTOMY, 'colostomy')
export const setVentriculostomy = makeActionCreator(DrainsAndTubesConstants.SET_VENTRICULOSTOMY, 'ventriculostomy')
export const setCsfColor = makeActionCreator(DrainsAndTubesConstants.SET_CSF_COLOR, 'csfColor')
export const setComments = makeActionCreator(DrainsAndTubesConstants.SET_COMMENTS_OTHER, 'comments')
export const setDrainsAndTubes = makeActionCreator(DrainsAndTubesConstants.SET_DRAINS_AND_TUBES, 'drainsAndTubes')
export const resetDrainsAndTubes = makeActionCreator(DrainsAndTubesConstants.RESET_DRAINS_AND_TUBES)
export const saveDrainsTubes = makeActionCreator(DrainsAndTubesConstants.SAVE_DRAINS_AND_TUBES)
